import { mapGetters, mapActions } from 'vuex';
import CookieJar from '@/utilities/cookieJar';

export const formSteps = {
    data () {
		return {
            showStepErrors: false
        };
    },
    computed: {
        noItemsAdded () {
            return this.getItemsByType ? this.getItemsByType.length < 1 : false;
        },
        otherCriteriaValid () {
            // additional conditions for validity may be set per section
            return true;
        },
        ...mapGetters('eoi', ['getEOI'])
    },
    mounted () {
        const formEle = document.querySelector('form');
        const focusableEles = formEle.querySelectorAll('.form-control, a, button');

        focusableEles[0].focus();

        if (this.getEOI) {
            Object.assign(this.formData, this.getEOI);
        }
	},
    methods: {
        saveAndSubmit (nextStep, validateStep = true, finalSubmit = false) {
            console.log('saveAndSubmit: ', nextStep, validateStep, finalSubmit);
            const formEle = document.querySelector('form');
            const focusableEles = formEle.querySelectorAll('.form-control, a, button');

            this.showStepErrors = true;
            if (!validateStep || (this.isValid(this.$refs.form) && !this.noItemsAdded && this.otherCriteriaValid)) {
                /* If we're continuing (validateStep is true) we want to save the next step as the one to return to,
                otherwise, we should return the user to the one they saved last */
                const returnStep = validateStep ? nextStep : this.$route.name;

                // set ua_submiteoi to 1/true if this is the final submission
                this.formData.ua_submiteoi = finalSubmit ? 1 : 2;

                this.submitEOI(finalSubmit, returnStep, nextStep);
            } else {
                window.scrollTo(0, 0);
                focusableEles[0].focus();
            }
        },
        submitEOI (finalSubmit, returnStep, nextStep) {
            this.updateEOI(this.formData).then((res) => {
                if (res === true) {
                 // if it's NOT the last step, update the current step
                if (!finalSubmit) {
                    this.updateCurrentStep(returnStep);
                } else {
                    window.localStorage.removeItem('postcodeChecked');
                }
                this.$router.push({ name: nextStep });
            } else if (res.status === 401) {
                this.redeemToken({
                    refreshtoken: CookieJar.get(`${process.env.VUE_APP_COOKIE_PREFIX}refresh_token`),
                    businessunit: process.env.VUE_APP_BUSINESS_UNIT
                }).then((res) => {
                    if (res === true) {
                        this.submitEOI(finalSubmit, returnStep, nextStep);
                        return true;
                    }
                    this.$router.push({ name: 'Login' });
                }).catch(() => {
                    this.$router.push({ name: 'Login' });
                });
            }
            }).catch((err) => {
                this.error = err.message;
             });
        },
        ...mapActions('auth', ['redeemToken']),
        ...mapActions('eoi', ['updateEOI', 'updateCurrentStep'])
    }
  };
